import {useApiQuery, LogUtils} from '@wallaby-ui/core';
import {useEffect} from 'react';

import {NUMBER_RANGE_REDUCER_STATE_ID} from '../number_range_constants';
import {numberRangeSlice} from '../number_range_slice';
import {NumberRangeMap} from '../number_range_types';
import {LIBRARY_NAME} from 'src/js/common/constants';
import {useAppDispatch, useAppSelector} from 'src/js/store_hooks';

const logger = LogUtils.getLogger('useLoadNumberRange', LIBRARY_NAME);

export interface UseLoadNumberRangeReturnValue {
  isLoading: boolean;
  error: unknown;
}

export function useLoadNumberRange(
  apiUrl: string
): UseLoadNumberRangeReturnValue {
  const isInitialized = useAppSelector(
    (state) => state[NUMBER_RANGE_REDUCER_STATE_ID]?.isInitialized
  );

  const {data, isLoading, error} = useApiQuery<NumberRangeMap>(
    [apiUrl],
    null,
    {
      axiosConfig: {url: apiUrl},
      reactQueryOptions: {
        enabled: !isInitialized,
      },
    },
    false
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (data && !isInitialized) {
      dispatch(
        numberRangeSlice.actions.addNumberRangeMap({numberRangeMap: data})
      );
    }
  }, [data, dispatch, isInitialized]);

  useEffect(() => {
    if (error) {
      logger.warn(`Error when loading number range!\n ${error}`);
    }
  }, [error]);

  return {isLoading, error};
}
